import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { QUESTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { QuestionProjectsPage } from '@/features/question/pages/QuestionProjectsPage';
import { projectManagementSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/projects')({
  beforeLoad: () => requirePermission(QUESTION_PERMISSIONS.PROJECT_VIEW),
  validateSearch: projectManagementSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Project Management">
      <Suspense fallback={<PageLoader />}>
        <QuestionProjectsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
